import { Form, Modal, ModalProps } from 'antd';
import { useState } from 'react';
import { StockItem } from '@/core/domain/stock/StockItems/StockItems.types';
import StockTransferSelectItemsList from './StockTransferSelectItemsList';
import { StockTransferFormValues } from '@/core/domain/stock/Operations/Operations.types';

interface Props extends ModalProps {
  companyId?: number;
  onCancel: VoidFunction;
  selectedItems?: StockItem[];
}

export default function StockTransferSelectItemsModal({
  companyId,
  selectedItems,
  ...props
}: Props) {
  const form = Form.useFormInstance<StockTransferFormValues>();

  const [selectedStockItems, setSelectedStockItems] = useState<StockItem[]>([]);

  async function onSubmit() {
    try {
      if (selectedItems) {
        const fullArray = [...(selectedItems || []), ...selectedStockItems];

        const filteredArray = fullArray.reduce((acc, item) => {
          const hasItem = acc.some(
            (accItem) =>
              (item.partId !== null && accItem.partId === item.partId) ||
              (item.consumableId !== null &&
                accItem.consumableId === item.consumableId),
          );
          if (!hasItem) {
            return [...acc, item];
          }
          return acc;
        }, [] as StockItem[]);

        form.setFieldValue('items', filteredArray);
      }

      setSelectedStockItems([]);
      props.onCancel();
    } catch {}
  }

  return (
    <Modal
      {...props}
      title="Adicionar itens"
      width="100%"
      destroyOnClose
      onOk={onSubmit}
      onCancel={props.onCancel}
      okText="Adicionar"
    >
      <StockTransferSelectItemsList
        open={props?.open}
        companyId={companyId}
        selectedItems={selectedItems}
        selectedStockItems={selectedStockItems}
        setSelectedStockItems={setSelectedStockItems}
      />
    </Modal>
  );
}
